import React from "react";

export const PageHeader = ({ overline, title, description, actions, testid }) => (
    <header className="px-8 py-8 border-b border-[var(--border)] bg-white" data-testid={testid}>
        <div className="flex items-start justify-between gap-6 flex-wrap">
            <div>
                {overline && <div className="overline mb-2">{overline}</div>}
                <h1 className="text-3xl sm:text-4xl tracking-tight font-bold text-[var(--text-primary)]">
                    {title}
                </h1>
                {description && (
                    <p className="mt-2 text-[15px] text-[var(--text-secondary)] max-w-2xl">{description}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
        </div>
    </header>
);

export const KPICard = ({ label, value, sub, testid, accent }) => (
    <div className="swiss-section p-5 flex flex-col" data-testid={testid}>
        <div className="overline mb-2">{label}</div>
        <div className={`mono text-[28px] font-semibold leading-none tracking-tight ${accent ? "text-[var(--accent)]" : ""}`}>
            {value}
        </div>
        {sub && <div className="text-[12px] text-[var(--text-secondary)] mt-2 font-mono">{sub}</div>}
    </div>
);

export const Empty = ({ title = "Nothing here yet", description, action, testid }) => (
    <div className="swiss-section p-12 flex flex-col items-center text-center" data-testid={testid}>
        <div className="w-14 h-14 mb-4 border-2 border-[var(--primary)] flex items-center justify-center" aria-hidden="true">
            <div className="w-6 h-6 bg-[var(--primary)]" />
        </div>
        <h3 className="text-xl font-bold tracking-tight">{title}</h3>
        {description && <p className="text-[14px] text-[var(--text-secondary)] mt-2 max-w-md">{description}</p>}
        {action && <div className="mt-5">{action}</div>}
    </div>
);

export const Pill = ({ children, color = "#111827", bg = "transparent", testid }) => (
    <span
        className="inline-flex items-center gap-1 px-2 py-1 text-[11px] font-mono uppercase tracking-wider border"
        style={{ color, borderColor: color, background: bg }}
        data-testid={testid}
    >
        {children}
    </span>
);

export const Skeleton = ({ className = "" }) => (
    <div className={`bg-[var(--surface-active)] animate-pulse ${className}`} aria-hidden="true" />
);
